<template>
  <div id="citySingle" class="viewport">
  
  
      <div class="columns">
        <div class="column">
          <h1>Stadt {{city.city}}</h1>
        </div>
        <div class="column alignRight">
          <button class="button buttonSave is-pulled-right" v-on:click="citySave">Speichern</button>
          <router-link tag="button" class="button is-pulled-right" :to="{ name: 'Cities' }">Zurück</router-link>
        </div>
      </div>

  
    <div class="userkeyfacts">
      <div class="columns">
        <div class="column">
          <div class="borderround">
            
            <h2>Facts</h2>
            <div class="user_name"><input v-model="city.city"><label>Stadt</label></div>
            <div class="user_role">            
                <select v-model="city.land">
                  <option value="" :selected="city.land == ''">...auswählen</option>
                  <option value="bb" :selected="city.land == 'bb'">Brandenburg (bb)</option>
                  <option value="be" :selected="city.land == 'be'">Berlin (be)</option>
                  <option value="bw" :selected="city.land == 'bw'">Baden-Württemberg (bw)</option>
                  <option value="by" :selected="city.land == 'by'">Bayern (by)</option>
                  <option value="hb" :selected="city.land == 'hb'">Bremen (hb)</option>
                  <option value="he" :selected="city.land == 'he'">Hessen (he)</option>
                  <option value="hh" :selected="city.land == 'hh'">Hamburg (hh)</option>
                  <option value="mv" :selected="city.land == 'mv'">Mecklenburg-Vorpommern (mv)</option>
                  <option value="ni" :selected="city.land == 'ni'">Niedersachsen (ni)</option>
                  <option value="nrw" :selected="city.land == 'nw'">Nordrhein-Westfalen (nrw)</option>
                  <option value="rp" :selected="city.land == 'rp'">Rheinland-Pfalz (rp)</option>
                  <option value="sh" :selected="city.land == 'sh'">Schleswig-Holstein (sh)</option>
                  <option value="sl" :selected="city.land == 'sl'">Saarland (sl)</option>
                  <option value="sn" :selected="city.land == 'sn'">Sachsen (sn)</option>
                  <option value="st" :selected="city.land == 'st'">Sachsen-Anhalt (st)</option>
                  <option value="th" :selected="city.land == 'th'">Thüringen (th)</option>

                </select>
                <label>Bundesland</label>
            </div>  
            <div class="stadtteile">
                <span v-for="district in city.districts">{{district}}</span>
            </div>
          </div>
        </div>
        <div class="column">

          <div class="borderround">          
            <h2>Stadt Info</h2>
            <textarea class="cityinfo" v-model="city.cityinfo">{{city.cityinfo}}</textarea>
          </div>
        </div>
      </div>
    </div>  
    
    <div class="buttonbox">
    </div>
  </div>
</template>
<script>
export default {
  name: "CitySingle",  
  props: ['cityid'],
  data() {
      return {
            city: { city: "", cityinfo:"", land:"", districts: [] },
            buttonText: 'Speichern'
        }
  },
  watch: {
    'city.city' : {
          handler: function(val, oldVal){ console.log('user changed from '+oldVal+' to ' + val); $('.buttonSave','#citySingle').text(this.buttonText); }
        },
    'city.cityinfo' : {
          handler: function(val, oldVal){ console.log('user changed'); $('.buttonSave','#citySingle').text(this.buttonText); }
        },
    'city.land' : {
          handler: function(val, oldVal){ console.log('user changed'); $('.buttonSave','#citySingle').text(this.buttonText); }
        },
/*
    'user_rights': {
          handler: function(val, oldVal){ console.log('user_rights changed'); this.user.user_rights = this.user_rights; $('.buttonSave','#userSingle').text(this.buttonText); }      
    },
*/
    deep: true
  },
  sockets: {
    getCityByID(r){
      //console.log('got user')
      //console.log(r)
      this.city = r 
    },
    
    citySaved(r){
      
      var $this = this;
      
      //console.log('user saved');
      //console.log(r);
      
      if(r.success == true )
      setTimeout( function(){ $('.buttonSave','#citySingle').html('<i class="fa fa-check"></i>') },1000);
    },
    
    
    
  },
  methods: {
/*
    citySaveValue(user, field, value){
      this.$socket.emit('citySaveValue', { update: { id: city.id, field: field, value: value, oldValue: this.oldValue }, quiet: 0 } );      
    },
*/
    
    citySave(e) {
      $(e.currentTarget).html('<i class="fa fa-spinner fa-pulse"></i>');
      //console.log('userSave');
      var city = this.city
//          user.user_rights = this.user_rights;
          
      this.$socket.emit('citySave', { update: { city: city }, quiet: 0 } );            
    },
    
  },
  mounted: function(){
    //console.log('userSingle mounted')
    
    if( this.cityid == "new" )
    this.city.id = 'new'
    else    
    this.$socket.emit('getCityByID', { cityid: this.cityid });
  },
  created: function(){
    //console.log('id: ' + this.cityid);
    //console.log(this);
  },  
  

  
}  
</script>
<style>
  textarea.cityinfo { 
    display: block;
    padding: 0.43333em 0.93333em;
    border-radius: 3px;
    border: 1px solid #ccc;
    width: 100%;
    min-height: 300px;
    white-space: pre-wrap;
    margin: 0 !important;
  }
  .stadtteile {
    padding: 0.43333em 0.93333em;
    border-radius: 3px;
    border: 1px solid #ccc;
    width: 100%;
    min-height: 199px;
    white-space: pre-wrap;
  }
</style>